import { useEffect, useState } from "react";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import "dayjs/locale/vi";
import { KbvPluginService } from "@/services/kbvPluginService";
import hotIcon from "../assets/hot-icon.svg";
import timeIcon from "../assets/time.svg";
import { absUrl, useSiteOrigin } from "../useSiteOrigin";
import { useDesktop } from "../useDesktop";
import "./hot-news.css";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.locale("vi");

const TZ = "Asia/Ho_Chi_Minh";

function NewsItem({ article, isLast, origin }) {
  const { title, thumbnail_url, published_at, slug } = article || {};
  const imageUrl = thumbnail_url || "";
  const href = absUrl(origin, `/tin-tuc/bai-viet/${slug || ""}`);

  return (
    <a className={`kbv-hot-news__item${isLast ? " is-last" : ""}`} href={href}>
      <div className="kbv-hot-news__thumb">
        {imageUrl ? <img src={imageUrl} alt={title || ""} loading="lazy" /> : null}
      </div>
      <div className="kbv-hot-news__body">
        <h4 className="kbv-hot-news__item-title">{title}</h4>
        {published_at ? (
          <div className="kbv-hot-news__time">
            <img src={timeIcon} alt="" />
            <time dateTime={published_at}>{dayjs(published_at).tz(TZ).fromNow()}</time>
          </div>
        ) : null}
      </div>
    </a>
  );
}

export default function HotNewsSideBar() {
  const desktop = useDesktop();
  const origin = useSiteOrigin();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!desktop) return undefined;
    let cancelled = false;
    setLoading(true);
    KbvPluginService.fetchNewsList({ page: 1, limit: 5, order: "DESC" })
      .then((list) => {
        if (!cancelled) setArticles(Array.isArray(list) ? list : []);
      })
      .catch(() => {
        if (!cancelled) setArticles([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [desktop]);

  if (!desktop) return null;
  if (!loading && articles.length === 0) return null;

  return (
    <aside className="kbv-home kbv-hot-news" aria-label="Tin thể thao">
      <div className="kbv-hot-news__card">
        <div className="kbv-hot-news__head">
          <img src={hotIcon} alt="" />
          <span className="kbv-hot-news__title">Tin Thể Thao</span>
        </div>

        {loading ? (
          <div className="kbv-hot-news__empty">Đang tải...</div>
        ) : (
          <>
            <div className="kbv-hot-news__list">
              {articles.map((article, index) => (
                <NewsItem
                  key={article.id ?? index}
                  article={article}
                  isLast={index === articles.length - 1}
                  origin={origin}
                />
              ))}
            </div>
            <a className="kbv-hot-news__more" href={absUrl(origin, "/tin-tuc")}>
              Xem tất cả
            </a>
          </>
        )}
      </div>
    </aside>
  );
}
